export const IT_IT_KICORE = {
 "catalog": {
 "6 meses": "6 mesi",
 "1 año": "1 anno",
 "Próximos 12 meses": "I prossimi 12 mesi",
 "El correo electrónico no es válido": "L'indirizzo email non è valido",
 "la versión": "la versione",
 "publicada": "pubblicata",
 "Escribe la versión para confirmar": "Scrivi la versione per confermare",
 "Es la versión en distribución: al borrarla se retira también el puntero del canal y los equipos dejarán de recibir actualizaciones desde aquí.": "È la versione in distribuzione: eliminandola si rimuove anche il puntatore del canale e i dispositivi smetteranno di ricevere aggiornamenti da qui.",
 "Se eliminará el paquete y su manifest. Los equipos que ya la tengan instalada no se ven afectados.": "Verranno eliminati il pacchetto e il suo manifest. I dispositivi che la hanno già installata non sono interessati.",
 "Destino": "Destinazione",
 "Sin declarar": "Non dichiarata",
 "Destino de la versión": "Destinazione della versione",
 "Se publicó antes de declarar destino: se trata como dirigida a equipos": "Pubblicata prima che esistessero le destinazioni: viene trattata come diretta ai dispositivi",
 "Esta versión se publicó sin declarar destino, así que se trata como dirigida a equipos": "Questa versione è stata pubblicata senza destinazione, quindi viene trattata come diretta ai dispositivi",
 "Es la versión en distribución, así que el cambio tiene efecto de inmediato": "È la versione in distribuzione, quindi la modifica ha effetto immediato",
 "No está en distribución: el cambio tendrá efecto cuando se publique": "Non è in distribuzione: la modifica avrà effetto quando verrà pubblicata",
 "¿A qué va dirigido este software?": "A chi è destinato questo software?",
 "Equipos": "Dispositivi",
 "Aplicaciones de usuario": "Applicazioni utente",
 "Aplicación de usuario": "Applicazione utente",
 "Core comprueba que el equipo esté registrado y con la suscripción en regla": "Core verifica che il dispositivo sia registrato e con l’abbonamento in regola",
 "Se descarga sin comprobar nada en Core, porque no hay equipo que comprobar": "Viene scaricato senza alcuna verifica in Core, perché non c’è alcun dispositivo da verificare",
 "Destino del software": "Destinazione del software",
 "Cambiar destino": "Cambia destinazione",
 "Destino actualizado": "Destinazione aggiornata",
 "Consultando el destino actual": "Consultazione della destinazione attuale",
 "Dejará de comprobarse la suscripción": "L’abbonamento non verrà più verificato",
 "Cualquiera con un token válido podrá descargar este software, sin pasar por Core.": "Chiunque abbia un token valido potrà scaricare questo software, senza passare da Core.",
 "El cambio se aplica a todas las versiones publicadas de este firmware": "La modifica si applica a tutte le versioni pubblicate di questo firmware",
 "Gestión de versiones de firmware OTA": "Gestione delle versioni di firmware OTA",
 "el firmware": "il firmware",
 "el canal": "il canale",
 "la variante": "la variante",
 "la carpeta": "la cartella",
 "Eliminar definitivamente": "Elimina definitivamente",
 "Esta acción no se puede deshacer": "Questa azione non può essere annullata",
 "Se eliminarán todas las versiones que cuelgan de esta ruta, incluidas las que estén en distribución. Los equipos dejarán de recibir actualizaciones desde aquí.": "Verranno eliminate tutte le versioni sotto questo percorso, comprese quelle in distribuzione. I dispositivi smetteranno di ricevere aggiornamenti da qui.",
 "Se eliminará": "Sarà eliminato",
 "Calculando lo que contiene": "Calcolo del contenuto",
 "Escribe la ruta para confirmar": "Scrivi il percorso per confermare",
 "Nuevo firmware": "Nuovo firmware",
 "Nuevo canal": "Nuovo canale",
 "Nueva variante": "Nuova variante",
 "Nueva versión": "Nuova versione",
 "Sin versiones publicadas": "Nessuna versione pubblicata",
 "Se creará el firmware": "Verrà creato il firmware",
 "Se creará el canal": "Verrà creato il canale",
 "Se creará la variante": "Verrà creata la variante",
 "Las carpetas del almacén nacen con su primera versión": "Le cartelle dell’archivio nascono con la loro prima versione",
 "Publicar una versión": "Pubblica una versione",
 "Publicar": "Pubblica",
 "Nuevo o existente": "Nuovo o esistente",
 "Sin variante": "Senza variante",
 "Se publicará en": "Sarà pubblicata in",
 "Esa versión ya existe en este destino": "Questa versione esiste già in questa destinazione",
 "Solo se admiten letras, números, punto, guion y guion bajo": "Sono ammessi solo lettere, numeri, punto, trattino e trattino basso",
 "Al publicarla, los equipos del canal empezarán a descargarla": "Una volta pubblicata, i dispositivi del canale inizieranno a scaricarla",
 "Subiendo el paquete": "Caricamento del pacchetto",
 "Procesando en el servidor: checksum y manifest": "Elaborazione sul server: checksum e manifest",
 "Quitar": "Rimuovi",
 "Buscar versión": "Cerca versione",
 "Ver como tabla": "Vedi come tabella",
 "Ver como tarjetas": "Vedi come schede",
 "Ninguna versión coincide con la búsqueda": "Nessuna versione corrisponde alla ricerca",
 "Subir un nivel": "Sali di un livello",
 "Todos los firmwares": "Tutti i firmware",
 "Variante": "Variante",
 "canal": "canale",
 "canales": "canali",
 "variante": "variante",
 "variantes": "varianti",
 "O pulsa para elegirlo": "Oppure clicca per sceglierlo",
 "versión": "versione",
 "carpeta": "cartella",
 "Selecciona un firmware o un canal para ver su contenido": "Seleziona un firmware o un canale per vedere il suo contenuto",
 "Carpetas": "Cartelle",
 "Versiones": "Versioni",
 "versiones": "versioni",
 "carpetas": "cartelle",
 "Selecciona un canal para ver su contenido": "Seleziona un canale per vedere il suo contenuto",
 "Esta carpeta solo contiene otras carpetas": "Questa cartella contiene solo altre cartelle",
 "Firmwares": "Firmware",
 "Firmware": "Firmware",
 "En distribución": "In distribuzione",
 "Poner en distribución": "Metti in distribuzione",
 "Ninguna versión en distribución": "Nessuna versione in distribuzione",
 "Eliminar y retirar de distribución": "Elimina e ritira dalla distribuzione",
 "Descargar": "Scarica",
 "Publicada": "Pubblicata",
 "Actualizar": "Aggiorna",
 "Sin firmwares publicados": "Nessun firmware pubblicato",
 "Selecciona un canal para ver sus versiones": "Seleziona un canale per vedere le sue versioni",
 "Arrastra aquí el paquete de firmware": "Trascina qui il pacchetto del firmware",
 "O pulsa para elegirlo y completar los datos de la versión": "Oppure clicca per sceglierlo e completare i dati della versione",
 "Un firmware o un canal nuevo nace al subir su primera versión": "Un nuovo firmware o canale nasce caricando la sua prima versione",
 "Variante (opcional)": "Variante (opzionale)",
 "Distingue compilaciones del mismo canal, por ejemplo rpi4": "Distingue le build dello stesso canale, ad esempio rpi4",
 "Versiones de firmware": "Versioni del firmware",
 "Firmware OTA": "Firmware OTA",
 "Carpeta": "Cartella",
 "Publicada por": "Pubblicata da",
 "Archivo": "File",
 "Tamaño": "Dimensione",
 "Acciones": "Azioni",
 "Marcar latest": "Segna come latest",
 "¿Marcar esta versión como latest?": "Segnare questa versione come latest?",
 "Los dispositivos del canal se actualizarán a esta versión": "I dispositivi del canale si aggiorneranno a questa versione",
 "¿Borrar la versión latest?": "Eliminare la versione latest?",
 "Es la versión latest del canal: se borrará también el puntero": "È la versione latest del canale: verrà eliminato anche il puntatore",
 "Productos": "Prodotti",
 "Subir versión": "Carica versione",
 "Versión marcada como latest": "Versione segnata come latest",
 "Versión borrada correctamente": "Versione eliminata correttamente",
 "Las carpetas se crean al subir su primera versión": "Le cartelle vengono create caricando la loro prima versione",
 "Producto": "Prodotto",
 "Canal": "Canale",
 "Target (opcional)": "Target (opzionale)",
 "Subcarpeta para diferenciar builds, por ejemplo rpi4": "Sottocartella per distinguere le build, ad esempio rpi4",
 "Campo obligatorio": "Campo obbligatorio",
 "Seleccionar archivo": "Seleziona file",
 "Marcar como latest": "Segna come latest",
 "Formato no permitido": "Formato non consentito",
 "Selecciona el archivo de firmware": "Seleziona il file del firmware",
 "Versión subida correctamente": "Versione caricata correttamente",
 "Subir": "Carica",
 "Caducidad suscripción": "Scadenza abbonamento",
 "Cambiar tarifa": "Cambiare la tariffa",
 "Selecciona la tarifa destino para las tarjetas seleccionadas": "Seleziona la tariffa di destinazione per le carte selezionate", 
 "Selecciona tarjetas y una tarifa": "Seleziona le carte e una tariffa", 
 "Algunas tarjetas no se pudieron actualizar": "Impossibile aggiornare alcune carte", 
 "Actualizadas": "Aggiornate", 
 "Fallidas": "Fallite", 
"Error 404": "Errore 404", 
 "Detalles Administrativos": "Dettagli amministrativi", 
 "Detalles  M2M": "Dettagli M2M", 
 "Search": "Ricerca", 
 "Reset": "Ripristina", 
 "Instalaci\u00f3n/Pedido": "Installazione/ordine", 
 "Cliente": "Cliente", 
 "Estado": "Estato", 
 "Desactivada": "Disabilitato", 
 "Activada": "Attivato", 
 "Inactiva nueva": "Nuovo inattivo", 
 "Lista para activaci\u00f3n": "Elenco per l'attivazione", 
 "Desconocido": "Uno sconosciuto", 
 "Consumo diario": "Consumo giornaliero", 
 "Consumo mensual": "Consumo mensile", 
 "Comienzo \u00faltima conexi\u00f3n": "Inizia l'ultima connessione", 
 "Fin \u00faltima conexi\u00f3n": "End Ultimate Connection", 
 "Compa\u00f1\u00eda de red": "Azienda di rete", 
 "C\u00f3digo de pa\u00eds": "Prefisso internazionale", 
 "Tipo de red": "Tipo di rete", 
 "Tipo de tarifa": "Tipo di tasso", 
 "Zona 1": "Zona 1", 
 "Sin asignar": "Non assegnato", 
 "Cambiar ciclo vida": "Cambiare il ciclo di vita", 
 "Por favor, seleccione una opci\u00f3n": "Per favore selezionate un'opzione", 
 "Desactivar": "Disattivare", 
 "Activar": "Attivare", 
 "Test": "Test", 
 "Estado GSM": "Stato GSM", 
 "Estado GPRS": "Stato GPRS", 
 "Buscar": "Cercare", 
 "Borrar": "Eliminare", 
 "Nombre": "Nome", 
 "Descripci\u00f3n": "Descrizione", 
 "UUID placa": "Distintivo UUID", 
 "Estado instalaci\u00f3n": "Stato dell'installazione", 
 "Desconectada": "Disconnesso", 
 "Conectada": "Collegato", 
 "Deshabilitada": "Disabilitato", 
 "Habilitada": "Abilitato", 
 "Detalles": "Dettagli", 
 "No se pudieron actualizar los datos": "Impossibile aggiornare i dati", 
 "Pools actualizados correctamente": "Pool aggiornati correttamente", 
 "Tarjetas activas / tarjetas totales": "Carte attive / carte totali", 
 "Consumo del pool / Pool total": "Consumo piscina / Totale piscina", 
 "Gasto estimado del pool": "Spesa stimata per la piscina", 
 "\u00daltima actualizaci\u00f3n": "Ultimo aggiornamento", 
 "Refrescar": "Ricaricare", 
 "Actualizar token de acceso": "Aggiornare il token di accesso", 
 "Por favor, complete este campo": "Si prega di completare questo campo", 
 "Enviar": "Inviare", 
 "Placa creada correctamente": "piastra creata con successo", 
 "Placa actualizada correctamente": "Targa aggiornata con successo", 
 "MAC err\u00f3nea": "MAC errato", 
 "SSID err\u00f3neo": "SSID errato", 
 "Nuevo kiwi": "Nuovo kiwi", 
 "Informaci\u00f3n de kiwi": "Informazioni sui kiwi", 
 "Guardar": "Mantenere", 
 "UUID err\u00f3neo": "UUID errato", 
 "Nuevo kibox": "Nuovo kibox", 
 "Informaci\u00f3n de kibox con UUID": "Informazioni Kibox con UUID", 
 "Informaci\u00f3n de kibox": "Informazioni Kibox", 
 "Habr\u00e1 mas de una placa con ese uuid.\u00bfEst\u00e1 seguro de esto?": "Ci sar\u00e0 pi\u00f9 di una piastra con quell'Uuid. Ne sei sicuro?", 
 "Modelo placa": "Modello a piastra", 
 "Seleccionar opci\u00f3n": "Selezionare l'opzione", 
 "Tarda demasiado en encenderse": "Ci vuole troppo tempo per accendersi", 
 "Usuario": "Utente", 
 "Nombre de usuario": "Nome utente", 
 "Rol": "Ruolo", 
 "Organizaci\u00f3n": "Organizzazione", 
 "Apellidos": "Cognomi", 
 "Email": "E-mail", 
 "Complete los campos obligatorios": "Completa i campi richiesti", 
 "Las contrase\u00f1as tienen que ser iguales": "Le password devono essere le stesse", 
 "Nombre de Usuario": "Nome utente", 
 "Correo electr\u00f3nico": "E-mail", 
 "Contrase\u00f1a": "Parola d'ordine", 
 "Repetir contrase\u00f1a": "Ripeti la password", 
 "Selecciona organizaci\u00f3n": "Seleziona l'organizzazione", 
 "Nivel": "Livello", 
 "Selecciona un rol": "Seleziona un ruolo", 
 "Superadministrador": "Super amministratore", 
 "Administrador": "Amministratore", 
 "Operador": "Operatore", 
 "Visitante": "Visitatore", 
 "Activo": "Risorsa", 
 "Crear cuenta": "Creare un account", 
 "Inicio": "Inizio", 
 "Nuevo equipo": "Nuova squadra", 
 "Stock": "Azione", 
 "Asignaciones": "Assegnazioni", 
 "Lista equipos": "Elenco delle squadre", 
 "Instalaciones": "Installazioni", 
 "Listado M2M": "Listato M2M", 
 "Listado Pools": "Listato Pools", 
 "Soporte": "Medio", 
 "Crear Usuario": "Creare un utente", 
 "Lista Usuarios": "Lista degli utenti", 
 "error": "errore", 
 "Informaci\u00f3n de tarjeta M2M con icc": "Informazioni sulla carta M2M con icc", 
 "Alias": "Alias", 
 "Life Cycle Status": "Stato del ciclo di vita", 
 "Pais": "Paese", 
 "Plan": "Piano", 
 "Estado Actual": "Stato attuale", 
 "\u00daltimo evento": "Ultimo evento", 
 "Tecno.Conexi\u00f3n": "Techno.Connection", 
 "\u00daltima Conexi\u00f3n": "Ultima connessione", 
 "Complete los campos": "Compila i campi", 
 "Inicio de sesi\u00f3n exitoso": "Accesso riuscito", 
 "Introduzca un nombre de usuario": "Inserisci un nome utente", 
 "Introduzca una contrase\u00f1a": "Inserisci una password", 
 "Iniciar sesi\u00f3n": "Login", 
 "Eliminar": "Eliminare", 
 "Editar": "Modificare", 
 "Asignar": "Assegnare", 
 "N\u00famero de serie err\u00f3neo": "Numero di serie errato", 
 "Nuevo KiWi": "Nuovo kiwi", 
 "Pedido": "Ordine", 
 "N serie": "N serie", 
 "Fecha fabricaci\u00f3n": "Data di fabbricazione", 
 "Estado de fabricaci\u00f3n": "Stato di produzione", 
 "KiWi terminado": "Kiwi finito", 
 "No se ha podido terminar": "Non poteva finire", 
 "Terminar": "Fine", 
 "Version hardware": "versione hardware", 
 "Modelo": "Modello", 
 "Tipo USB": "Tipo USB", 
 "Instalaci\u00f3n": "Facilit\u00e0", 
 "Cliente kiconex": "Cliente kiconex", 
 "Cliente final": "Cliente finale", 
 "N\u00famero de serie": "Numero di serie", 
 "kiconex plan": "Piano Kiconex", 
 "Nº dispositivos": "Nº dispositivi", 
 "Cuadro": "Grafico", 
 "Placa terminada": "Piatto finito", 
 "Opcionales": "Opzionale", 
 "Notas": "Notas", 
 "Crear nuevo dispositivo": "Creare un nuovo dispositivo", 
 "Bienvenido a kicore ¡la plataforma de gesti\u00f3n de Kiconex!": "Benvenuto in kicore, la piattaforma di gestione di Kiconex!", 
 "Ver en kiconex": "Vedi in Kiconex", 
 "ICC err\u00f3neo": "ICC sbagliato", 
 "Nombre instalaci\u00f3n": "Nome installazione", 
 "Nº serie": "Numero di serie", 
 "Versi\u00f3n hardware": "Versione hardware", 
 "Ninguno": "Nessuno", 
 "Chino": "Cinese", 
 "Basic": "Di Base", 
 "Professional": "Professionale", 
 "Premium": "Premio", 
 "No": "Ne pas", 
 "S\u00ed": "S\u00ec", 
 "Cable": "Filo", 
 "Fabricado": "Manufatto", 
 "Asignado": "Assegnato", 
 "Terminado": "Finito", 
 "Eliminado": "Rimosso", 
 "Volver": "Ritorno", 
 "Plan kiconex": "Piano Kiconex", 
 "¡MAC err\u00f3nea!": "MAC sbagliato!", 
 "Introduzca una MAC o IMEI v\u00e1lidos": "Inserisci un MAC o IMEI valido", 
 "Generar UUID": "Genera UUID", 
 "¡SSID err\u00f3neo!": "SSID sbagliato!", 
 "¡UUID err\u00f3neo!": "UUID sbagliato!", 
 "¡ICC err\u00f3neo!": "ICC sbagliato!", 
 "¡N\u00famero de serie err\u00f3neo!": "Numero di serie errato!", 
 "Grupo comercial": "Gruppo commerciale", 
 "Habilitaci\u00f3n": "Qualificazione", 
 "F\u00e1brica": "Fabbrica", 
 "Administraci\u00f3n": "Amministrazione", 
 "Gesti\u00f3n": "Gestione", 
 "Usuarios": "Utenti", 
 "Lista kibox": "Elenco kibox", 
 "Lista kiwi": "Elenco kiwi", 
 "Kibox asignados": "Kibox assegnati", 
 "Kiwis asignados": "Kiwis assegnati", 
 "No se conecta al WiFi": "Non si connette al Wi-Fi", 
 "Este pedido debe salir con una pegatina extra": "Questo ordine deve essere accompagnato da un adesivo aggiuntivo", 
 "Cambiar estado de la SIM": "Cambiare lo stato della sim", 
 "Estado de la SIM": "Stato SIM", 
 "Fruter\u00eda fulanito": "Tal dei tali fruttivendolo", 
 "Token actualizado correctamente": "Token aggiornato con successo", 
 "Usuario creado correctamente": "Utente creato con successo", 
 "No hay respuesta del servidor": "Nessuna risposta dal server", 
 "Error": "Errore", 
 "Error al cerrar sesi\u00f3n": "Errore alla disconnessione", 
 "Seleccionar idioma": "Seleziona la lingua", 
 "Espa\u00f1ol": "Spagnolo", 
 "Ingl\u00e9s": "Inglese", 
 "Franc\u00e9s": "Francese", 
 "Alem\u00e1n": "Tedesco", 
 "Portugu\u00e9s": "Portoghese", 
 "Italiano": "Italiano", 
 "UUID": "UUID", 
 "Nombre comercial": "Nome depositato", 
 "Pedido comercial": "Ordine commerciale", 
 "N\u00famero de serie comercial": "Numero di serie commerciale", 
 "Modelo del equipo": "Modello di attrezzatura", 
 "Estado Comercial": "Stato commerciale", 
 "Fecha Conexi\u00f3n": "Data Connessione", 
 "Subscripci\u00f3n": "Sottoscrizione", 
 "Comercial": "Commerciale", 
 "General": "Generale", 
 "Placa borrada correctamente": "Lastra cancellata con successo", 
 "Sistema": "Sistema", 
 "Privilegios": "Privilegi", 
 "Roles": "Ruoli", 
 "Usuario borrado correctamente": "Utente eliminato con successo", 
 "Cambiar contrase\u00f1a": "Cambiare la password", 
 "Columnas": "Colonne", 
 "Sin informaci\u00f3n": "Nessuna informazione", 
 "Cerrar": "Vicino", 
 "Cambiar": "Modifica", 
 "Por favor, seleccione una opcion": "Per favore selezionate un'opzione", 
 "¡Las contrase\u00f1as deben coincidir!": "¡Le password devono essere identiche!", 
 "La contrase\u00f1a es un campo obligatorio": "La password \u00e8 un campo obbligatorio", 
 "success": "successo", 
 "Contrase\u00f1a actualizada correctamente": "Password aggiornata con successo", 
 "Las contrase\u00f1as deben coincidir": "Le password devono essere identiche", 
 "Cambio de contrase\u00f1a usuario": "Cambio password utente", 
 "Debe seleccionar un rol": "Devi selezionare un ruolo", 
 "Rol creado correctamente": "Ruolo creato correttamente", 
 "Nuevo Rol": "Nuovo ruolo", 
 "Informaci\u00f3n de Rol": "Informazioni sul ruolo", 
 "Rol borrado correctamente": "Ruolo eliminato correttamente", 
 "Rol administrador": "Ruolo di amministratore", 
 "Sincronizar": "Sincronizzare", 
 "¡Sincronizar datos!": "¡Sincronizzare i dati!", 
 "Nombre, Organizaci\u00f3n y subscripci\u00f3n van a ser modificados por el valor que tengan en la plataforma Kiconex \u00bfEst\u00e1 seguro de esto?": "Nome, Organizzazione e abbonamento verranno modificati dal valore che hanno nella piattaforma Kiconex \u00bfSei sicuro di questo?", 
 "Usuario guardado correctamente": "Utente salvato con successo", 
 "Nuevo usuario": "Nuovo utente", 
 "Editando usuario": "Modifica utente", 
 "Software": "Software", 
 "Crear": "Creare", 
 "Ver": "Vedere", 
 "Finalizar": "Fine", 
 "Editar comercial": "Modifica commerciale", 
 "Gesti\u00f3n de placas de f\u00e1brica": "Gestione targhe di fabbrica", 
 "Asignaciones de f\u00e1brica": "Incarichi di fabbrica", 
 "Asignaci\u00f3n de placas de f\u00e1brica": "Assegnazione delle targhe di fabbrica", 
 "Gesti\u00f3n de placas de administraci\u00f3n": "Gestione del consiglio di amministrazione", 
 "mykiconex": "mykiconex", 
 "Gesti\u00f3n con plataforma mykiconex": "Gestione con piattaforma mykiconex", 
 "M2M": "M2M", 
 "Ver M2M": "Vedi M2M", 
 "Ver estado": "Visualizzare lo stato", 
 "Ver listado pools": "Vedi elenco pools", 
 "Refrescar pools": "Ricaricare pools", 
 "Actualizar token": "Token di aggiornamento", 
 "VPN": "VPN", 
 "Chat": "Chat", 
 "Ver privilegios": "Vedi privilegi", 
 "Editar privilegios": "Modificare i privilegi", 
 "Gesti\u00f3n de sistema": "Gestione del sistema", 
 "Gesti\u00f3n de usuarios": "Gestione utenti", 
 "Ver acceso a chat": "Visualizza l'accesso alla chat", 
 "Ver acceso a soporte": "Vedi l'accesso al supporto", 
 "Ver acceso a VPN": "Vedere Accesso VPN", 
 "Gesti\u00f3n de tarjetas M2M": "Gestione delle carte M2M", 
 "Autorizaci\u00f3n": "Autorizzazione", 
 "Fecha primera contrataci\u00f3n": "Prima data di assunzione", 
 "Fecha \u00faltima renovaci\u00f3n": "Ultima data di rinnovamento", 
 "Intervalo de renovaci\u00f3n (a\u00f1os)": "Intervallo di rinnovo (anni)", 
 "Fecha primera conexi\u00f3n": "Prima data di connessione", 
 "Privilegios guardados correctamente": "I privilegi salvati correttamente", 
 "Rol actualizado correctamente": "Ruolo aggiornato correttamente", 
 "N\u00famero Pedido": "Numero d'ordine", 
 "Asunto": "Affare", 
 "Asignado a": "Assegnato a", 
 "Fecha de Creaci\u00f3n": "Data di creazione", 
 "Pendiente": "In sospeso", 
 "Cambiar Estado": "Cambiare stato", 
 "Estado del Pedido actualizado correctamente": "Ordina stato aggiornato correttamente", 
 "Cliente Final": "Cliente finale", 
 "Referencia Presupuesto": "Riferimento di bilancio", 
 "Precio Total": "Prezzo totale", 
 "Ver en CRM": "Vedi in CRM", 
 "N\u00famero Presupuesto": "Numero di bilancio", 
 "En Proceso": "In corso", 
 "Anulado": "Annullato", 
 "Cambiar estado del pedido": "Cambia lo stato dell'ordine", 
 "Pedidos": "Ordini", 
 "Gesti\u00f3n de pedidos": "Gestione degli ordini", 
 "Error en la operaci\u00f3n": "Errore operativo", 
 "UUID de placa ya en uso": "Placca uuid gi\u00e0 in uso", 
 "Nueva Placa Guardada": "Nuova piastra salvata", 
 "Placa actualizada": "Piastra aggiornata", 
 "Placa borrada": "Piastra cancellata", 
 "Placas actualizadas": "Piatti aggiornati", 
 "SSID de kiwi ya en uso": "Kiwi ssid gi\u00e0 in uso", 
 "Nuevo KiWi Guardado": "Nuovo kiwi salvato", 
 "KiWi actualizado": "Kiwi aggiornato", 
 "KiWi borrado": "Kiwi cancellato", 
 "Token actualizado": "Token aggiornato", 
 "Nombre de rol ya en uso": "Nome del ruolo gi\u00e0 in uso", 
 "Rol actualizado": "Ruolo aggiornato", 
 "No puede eliminar un rol con dependencias": "Non pu\u00f2 eliminare un ruolo con le dipendenze", 
 "La clave ha expirado.": "La chiave \u00e8 scaduta.", 
 "Usuario no encontrado.": "Utente non trovato.", 
 "Las contrase\u00f1as son obligatorias.": "Le passwords sono obbligatorie.", 
 "Las contrase\u00f1as no coinciden.": "Le passwords non corrispondono.", 
 "Nombre de usuario ya en uso": "User name gi\u00e0 usato", 
 "Error del servidor.": "Errore del server.", 
 "El usuario no ha sido activado.": "L'utente non \u00e8 stato attivato.", 
 "Inicio de sesi\u00f3n con \u00e9xito": "Accesso riuscito", 
 "Contrase\u00f1a incorrecta": "Password errata", 
 "Fecha Renovaci\u00f3n": "Data di rinnovo", 
 "Tiempo Restante": "Tempo Rimasto", 
 " meses restantes": " mesi rimanenti", 
 "Pedidos a expirar": "Ordini di scadere", 
 "Descargar Informe": "Scarica il rapporto", 
 "Renovaciones": "Ristrutturazioni", 
 "Pr\u00f3ximo mes": "Il prossimo mese", 
 "Pr\u00f3ximos 3 meses": "I prossimi 3 mesi", 
 "Pr\u00f3ximos 6 meses": "I prossimi 6 mesi", 
 "Pr\u00f3ximo a\u00f1o": "L'anno prossimo", 
 "Ver renovaciones": "Vedi i lavori di ristrutturazione", 
 "Caducada": "Scaduto", 
 " d\u00edas restantes": " giorni rimanenti", 
 "Aceptar": "Accettare", 
 "Reiniciar": "Ricomincia", 
 "Sin organizaci\u00f3n": "Nessuna organizzazione", 
 "Ver pools": "Vedi pools", 
 "Alarmas": "Allarmi", 
 "Alarmas M2M": "Allarmi M2M", 
 "Sin alertas": "Senza avvisi", 
 "Advertencia": "Avvertimento", 
 "Critica": "Critica", 
 "Renovaciones expiradas": "Ristrutturazioni scadute", 
 "Pedidos pendientes": "Ordini in attesa", 
 "Tarjetas desactivadas desde hace mas de 12 meses": "Carte disattivate per pi\u00f9 di 12 mesi", 
 "Ver m\u00e1s": "Vedi altro", 
 "Creaci\u00f3n": "Creazione", 
 "Actualizaci\u00f3n": "Aggiornamento", 
 "Borrado": "Cancellato", 
 "Cambio de estado": "Cambiamento di stato", 
 "Cambio de contrase\u00f1a": "Cambio di password", 
 "Sincronizaci\u00f3n": "Sincronizzazione", 
 "Sin acci\u00f3n": "Nessuna azione", 
 "Fecha": "Data", 
 "Acci\u00f3n": "Azione", 
 "Tipo de objeto": "Tipo di oggetto", 
 "Identificador": "Identificatore", 
 "Placa": "Piatto", 
 "Hace 3 horas": "3 ore fa", 
 "Hace 1 d\u00eda": "1 giorno fa", 
 "Hace 3 d\u00edas": "3 giorni fa", 
 "Hace 1 semana": "1 settimana fa", 
 "Actividad": "Attivit\u00e0", 
 "Listado": "Elenco", 
 "Ver actividad": "Vedere l'attivit\u00e0", 
 "Privilegio": "Privilegio", 
 "No es posible personificar desde un personificado.": "Non \u00e8 possibile personificare da un personificato.", 
 "Personificaci\u00f3n": "Personificazione", 
 "Personificando al usuario": "Personificando l'utente", 
 "Volver a la sesi\u00f3n": "Vai alla sessione", 
 "Personificar": "Personificare", 
 "No es posible personificarse a si mismo.": "Non \u00e8 possibile personificare te stesso.", 
 "Comienzo Personificaci\u00f3n": "Inizio Personificazione", 
 "Fin Personificaci\u00f3n": "Fine personificazione", 
 "Ajustes": "Impostazioni", 
 "Actualizar listado": "Elenco degli aggiornamenti", 
 "Refrescar pedidos": "Aggiorna gli ordini", 
 "Refrescar ordenes de trabajo": "Aggiorna gli ordini di lavoro", 
 "de": "di", 
 "filtrados de": "filtrato da", 
 "Actualizar listado de organizaciones": "Elenco degli aggiornamenti di organizzazioni", 
 "Actualizar nombre, plan y organizaci\u00f3n de kibox": "Aggiorna il nome, il piano e l'organizzazione di Kibox", 
 "Actualizar listado de pedidos": "Elenco degli ordini di aggiornamento", 
 "Actualizar listado de ordenes de trabajo": "Elenco degli ordini di lavoro di aggiornamento", 
 "Actualizaci\u00f3n de listados": "Aggiornamento dell'elenco", 
 "Actualizado con exito": "Aggiornato con successo", 
 "Activa": "Attivo", 
 "Sin intervalo": "Nessun intervallo", 
 "Mostrar todo": "Mostra tutto", 
 "Estado de suscripci\u00f3n no compatible con el intervalo seleccionado": "Stato di abbonamento non compatibile con l'intervallo selezionato", 
 "Estado del plan": "Stato del piano", 
 "Caducado": "Fuori tempo", 
 "Inactivo": "Oziare", 
 "Cancelado": "Annullato", 
 "No procede": "Non procede", 
 "¡Orden de trabajo erronea!": "Ordine di lavoro errato!", 
 "Rellene el formulario correctamente": "Compilare correttamente il modulo", 
 "Orden de trabajo": "Ordine di lavoro", 
 "Su sesi\u00f3n va a ser cerrada": "La tua sessione sar\u00e0 chiusa", 
 "Su sesi\u00f3n se cerrar\u00e1 para aplicar los cambios": "Verrai disconnesso per applicare le modifiche", 
 "Inicie sesi\u00f3n de nuevo": "Accedi di nuovo", 
 "Posee una versi\u00f3n no compatible": "Ha una versione non compatibile", 
 "Consumo": "Consumo", 
 "Consumo de la SIM": "Consumo della SIM", 
 "Mensual": "Mensile", 
 "Diario": "Diario", 
 "UUID ya en uso": "UUID gi\u00e0 in uso", 
 "VPN creada correctamente": "VPN creata con successo", 
 "VPN actualizada correctamente": "VPN aggiornata con successo", 
 "Contrase\u00f1a copiada al portapapeles": "Password copiata negli appunti", 
 "Fallo al copiar la contrase\u00f1a": "Impossibile copiare la password", 
 "Nueva conexi\u00f3n VPN": "Nuova connessione VPN", 
 "Regenerar contrase\u00f1a": "Rigenera la password", 
 "Contrase\u00f1a VPN": "Password VPN", 
 "Copie la contrase\u00f1a antes de guardar, no volver\u00e1 a ser visible": "Copia la password prima di salvare, non sar\u00e0 pi\u00f9 visibile", 
 "VPN (antigua)": "VPN (vecchio)", 
 "Ver acceso a VPN (antigua)": "Visualizza l'accesso VPN (vecchio)", 
 "Ver VPN (antigua)": "Visualizza VPN (vecchio)", 
 "Ver VPN": "Visualizza VPN", 
 "Crear VPN": "Crea VPN", 
 "Editar VPN": "Modifica VPN", 
 "Ver informaci\u00f3n": "Vedi informazioni", 
 "Informaci\u00f3n placas": "Informazioni sulla targa", 
 "Modelo de hardware": "Modello hardware", 
 "Fecha de compilaci\u00f3n": "Data di costruzione", 
 "Versi\u00f3n de Daemon": "Versione demone", 
 "Fecha de actualizaci\u00f3n": "Data di aggiornamento", 
 "Actualizado": "Aggiornato", 
 "No actualizado": "Non aggiornato", 
 "Descargar fichero de configuraci\u00f3n": "Scarica il file di configurazione", 
 "Nunca": "Mai", 
 "Dispositivo": "Dispositivo", 
 "Router kiconex": "Router Kiconex", 
 "Fecha de expedici\u00f3n": "Data di emissione", 
 "\u00bfEst\u00e1 seguro de que desea eliminar este elemento?": "Sei sicuro di voler eliminare questo elemento?", 
 "Confirmaci\u00f3n de eliminaci\u00f3n": "Conferma dell'eliminazione", 
 "S\u00ed, eliminar": "S\u00ec, cancella", 
 "Cancelar": "Cancellare", 
 "Unidades de cable": "Unit\u00e0 cavo", 
 "En espera": "In attesa", 
 "En proceso": "In processo", 
 "UUID Original": "UUID Originale", 
 "El nombre es obligatorio": "Il nome è obbligatorio", 
 "UUID no v\u00e1lido": "UUID non valido", 
 "API Key borrada": "Chiave API eliminata", 
 "La fecha de expiraci\u00f3n debe ser posterior a la fecha actual": "La data di scadenza deve essere successiva alla data attuale", 
 "Clave editada correctamente": "Chiave modificata con successo", 
 "Clave creada correctamente": "Chiave creata con successo", 
 "Clave copiada al portapapeles": "Chiave copiata negli appunti", 
 "\u00bfEst\u00e1s seguro?": "Sei sicuro?", 
 "No podr\u00e1s volver a ver esta clave API. \u00bfDeseas continuar?": "Non potrai pi\u00f9 visualizzare questa chiave API. Vuoi continuare?", 
 "S\u00ed, cerrar": "S\u00ec, chiudi", 
 "La clave no volver\u00e1 a estar disponible": "La chiave non sar\u00e0 pi\u00f9 disponibile", 
 "\u00bfDeseas borrar esta clave API?": "Vuoi eliminare questa chiave API?", 
 "S\u00ed, borrar": "S\u00ec, elimina", 
 "Clave borrada correctamente": "Chiave eliminata con successo", 
 "Sin descripci\u00f3n": "Senza descrizione", 
 "Fecha de expiraci\u00f3n": "Data di scadenza", 
 "Editar clave API": "Modifica chiave API", 
 "Nueva clave API": "Nuova chiave API", 
 "Copiar clave": "Copia chiave", 
 "Clave API creada correctamente": "Chiave API creata con successo", 
 "Esta es tu clave API. No podr\u00e1s volver a consultarla en el futuro, c\u00f3piala y \u00fasala donde necesites": "Questa \u00e8 la tua chiave API. Non potrai visualizzarla di nuovo in futuro, copiala e usala dove necessario", 
 "Claves API": "Chiavi API", 
 "Listado de claves API": "Elenco delle chiavi API", 
 "Generar nueva clave": "Generare una nuova chiave", 
 "Editar claves": "Modifica chiavi", 
 "Editar tracker": "Modifica tracker", 
 "Modelo control": "Modello control", 
 "Clave API control": "Chiave API control", 
 "Clave API box": "Chiave API box", 
 "Actualizar claves de acceso para: ": "Aggiorna le chiavi di accesso per: ", 
 "Traductor de librer\u00edas": "Traduttore di librerie", 
 "Estado de subscripci\u00f3n": "Stato dell'abbonamento", 
 "Versi\u00f3n": "Versione", 
 "Sin versi\u00f3n": "Nessuna versione", 
 "Sin modelo": "Nessun modello", 
 "Primero seleccione un modelo": "Seleziona prima un modello", 
 "Tendr\u00e1 que volver a iniciar sesi\u00f3n para usar la nueva clave": "Dovrai accedere di nuovo per utilizzare la nuova chiave", 
 "El nombre de usuario es un campo obligatorio": "Il nome utente \u00e8 un campo obbligatorio", 
 "Pedido es un campo obligatorio": "L'ordine \u00e8 un campo obbligatorio", 
 "UUID es un campo obligatorio": "UUID \u00e8 un campo obbligatorio", 
 "Modelo y versi\u00f3n son campos obligatorios": "Il modello e la versione sono campi obbligatori", 
 "Renovaciones M2M expiradas": "Rinnovi M2M scaduti", 
 "Renovaciones de plan expiradas": "Rinnovi di piano scaduti", 
 "Ingrese el n\u00famero de meses": "Inserire il numero di mesi", 
 "Intervalo de renovaci\u00f3n": "Intervallo di rinnovo", 
 "suscripci\u00f3n": "abbonamento", 
 "suscripciones": "abbonamenti", 
 "Editando": "Modifica", 
 "Renovando": "Rinnovo", 
 "suscripciones actualizadas correctamente": "abbonamenti aggiornati correttamente", 
 "Pr\u00f3xima renovaci\u00f3n": "Prossimo rinnovo", 
 "Renovar": "Rinnovare", 
 "\u00bfD\u00f3nde encuentro mi clave?": "Dove trovo la mia chiave?", 
 "Clave API Cloud": "Chiave API Cloud", 
 "Clave API Cloud actualizada correctamente": "Chiave API Cloud aggiornata con successo", 
 "VPN Antigua": "VPN vecchio", 
 "Meses a renovar": "Mesi da rinnovare", 
 "Debe seleccionar un estado de suscripci\u00f3n": "Devi selezionare uno stato di abbonamento", 
 "Plan es obligatorio": "Il piano \u00e8 obbligatorio", 
 "Debe seleccionar un estado de suscripci\u00f3n M2M": "Devi selezionare uno stato di abbonamento M2M", 
 "ICC es obligatorio": "ICC \u00e8 obbligatorio", 
 "Hist\u00f3rico de suscripci\u00f3n": "Cronologia dell'abbonamento", 
 "Fecha de primera conexi\u00f3n": "Data della prima connessione", 
 "Fecha de renovaci\u00f3n": "Data di rinnovo", 
 "meses": "mesi", 
 "Realizado por": "Eseguito da", 
 "Eliminaci\u00f3n": "Eliminazione", 
 "Cancelaci\u00f3n": "Cancellazione", 
 "Preparaci\u00f3n": "Preparazione", 
 "Cambio de intervalo": "Cambio di intervallo", 
 "Cambio de plan": "Cambio di piano", 
 "Caducadas": "Scadute", 
 "Por vencer": "In scadenza", 
 "Cargando": "Caricamento", 
 "Gestionar perfil": "Gestisci profilo", 
 "Instalaci\u00f3n original": "Installazione originale", 
 "Actualizar en Kite": "Aggiorna in Kite", 
 "Debe seleccionar una suscripci\u00f3n de plan": "\u00c8 necessario selezionare un abbonamento al piano", 
 "Propietario": "Proprietario", 
 "Tarifa": "Tariffa", 
 "Nueva fecha": "Nuova data", 
 "Error al crear usuario": "Errore durante la creazione dell'utente", 
 "Error al obtener datos": "Errore durante il recupero dei dati", 
 "Error al cargar las claves API": "Errore al caricamento delle chiavi API", 
 "Error al guardar la clave": "Errore al salvataggio della chiave", 
 "Error al borrar la clave": "Errore al cancellamento della chiave", 
 "Error al editar la clave": "Errore alla modifica della chiave", 
 "Error al copiar la clave": "Errore al copia della chiave", 
 "No puedes cambiar la fecha de expiraci\u00f3n una vez creada": "Non puoi cambiare la data di scadenza una volta creata", 
 "No se puede devolver a Stock: la placa tiene repuestos asignados": "Impossibile tornare a Stock: la scheda ha pezzi di ricambio assegnati", 
 "Introduzca su correo electr\u00f3nico": "Inserisci il tuo indirizzo e-mail", 
 "Si el correo existe, recibir\u00e1 un mensaje con instrucciones para restablecer su contrase\u00f1a.": "Se l'indirizzo e-mail esiste, riceverai un messaggio con le istruzioni per reimpostare la password.", 
 "Enviar enlace de recuperaci\u00f3n": "Invia link di recupero", 
 "Volver al inicio de sesi\u00f3n": "Torna al login", 
 "Nueva contrase\u00f1a": "Nuova password", 
 "Restablecer contrase\u00f1a": "Reimposta password", 
 "El enlace de recuperaci\u00f3n ha caducado o ya ha sido utilizado. Solicite uno nuevo.": "Il link di recupero \u00e8 scaduto o \u00e8 gi\u00e0 stato utilizzato. Richiedine uno nuovo.", 
 "Error al restablecer la contrase\u00f1a": "Errore durante la reimpostazione della password", 
 "\u00bfOlvid\u00f3 su contrase\u00f1a?": "Password dimenticata?", 
 "Su contrase\u00f1a ha caducado": "La tua password \u00e8 scaduta", 
 "Han pasado m\u00e1s de 6 meses desde el \u00faltimo cambio. Por motivos de seguridad debe establecer una nueva contrase\u00f1a antes de continuar.": "Sono passati pi\u00f9 di 6 mesi dall'ultima modifica. Per motivi di sicurezza \u00e8 necessario impostare una nuova password prima di continuare.", 
 "Entendido": "Capito", 
 "La contrase\u00f1a debe tener al menos 12 caracteres.": "La password deve contenere almeno 12 caratteri.", 
 "La contrase\u00f1a debe incluir al menos tres de las siguientes categor\u00edas: may\u00fasculas, min\u00fasculas, n\u00fameros y caracteres especiales.": "La password deve includere almeno tre delle seguenti categorie: maiuscole, minuscole, numeri e caratteri speciali.", 
 "Cambiar ahora": "Cambia ora", 
 "Su contrase\u00f1a caducar\u00e1 pronto": "La tua password scadr\u00e0 presto", 
 "Le quedan {days} d\u00edas para cambiar su contrase\u00f1a. Pulse el bot\u00f3n para hacerlo ahora.": "Hai {days} giorno/i rimasto/i per cambiare la tua password. Fai clic sul pulsante per farlo ora.", 
 "copiado al portapapeles": "copiato negli appunti",
 "C\u00f3digos copiados al portapapeles": "Codici di recupero copiati negli appunti",
 "C\u00f3digos de recuperaci\u00f3n": "Codici di recupero",
 "Gu\u00e1rdelos en un lugar seguro. No se volver\u00e1n a mostrar. Cada uno sirve una sola vez si pierde el acceso a su aplicaci\u00f3n.": "Conservali in un luogo sicuro. Non verranno più visualizzati. Ognuno può essere utilizzato una volta se perdi l'accesso alla tua app.",
 "Copiar c\u00f3digos": "Copia codici",
 "Introduzca el c\u00f3digo": "Inserisci il codice",
 "C\u00f3digo incorrecto": "Codice errato",
 "Verificaci\u00f3n en dos pasos desactivada": "Verifica in due passaggi disabilitata",
 "Verificaci\u00f3n en dos pasos": "Verifica in due passaggi",
 "Introduzca uno de sus c\u00f3digos de recuperaci\u00f3n para desactivar la verificaci\u00f3n en dos pasos.": "Inserisci uno dei tuoi codici di recupero per disattivare la verifica in due passaggi.",
 "C\u00f3digo de recuperaci\u00f3n": "Codice di recupero",
 "Desactivar 2FA": "Disattiva 2FA",
 "Usar el c\u00f3digo de la aplicaci\u00f3n": "Usa il codice dell'app",
 "\u00bfNo tiene acceso a la app? Usar un c\u00f3digo de recuperaci\u00f3n": "Non hai accesso all'app? Usa un codice di recupero",
 "Su cuenta est\u00e1 protegida con un segundo factor. Para desactivarlo, introduzca un c\u00f3digo de su aplicaci\u00f3n de autenticaci\u00f3n.": "Il tuo account è protetto con un secondo fattore. Per disattivarlo, inserisci un codice dall'app di autenticazione.",
 "\u00d1ade una capa extra de seguridad. Necesitar\u00e1 una app como Google Authenticator para generar los c\u00f3digos.": "Aggiungi un ulteriore livello di sicurezza. Avrai bisogno di un'app come Google Authenticator per generare i codici.",
 "1. Escanee el c\u00f3digo QR con su aplicaci\u00f3n de autenticaci\u00f3n": "1. Scansiona il codice QR con la tua app di autenticazione",
 "\u00bfNo puede escanear? Introduzca esta clave manualmente": "Non riesci a scansionare? Inserisci questa chiave manualmente",
 "2. Introduzca el c\u00f3digo de 6 d\u00edgitos que muestra la app": "2. Inserisci il codice a 6 cifre visualizzato dall'app",
 "Su contrase\u00f1a ha caducado": "La tua password è scaduta",
 "Error al obtener datos": "Errore durante il recupero dei dati",
 "Error al copiar": "Copia fallita",
 "Tarifa es obligatorio": "La tariffa \u00e8 obbligatoria",
 "M2M actualizado correctamente": "M2M aggiornato con successo",
 "Error al actualizar M2M": "Errore durante l'aggiornamento di M2M",
 "Enlace no v\u00e1lido o expirado. P\u00eddalo de nuevo o p\u00f3ngase en contacto con un administrador.": "Link non valido o scaduto. Richiedilo di nuovo o contatta un amministratore.",
 "Datos personales": "Dati personali",
 "Seguridad y acceso": "Sicurezza e accesso",
 "Zona horaria": "Fuso orario",
 "Seleccione una zona horaria": "Selezionare un fuso orario",
 "Sin instalaci\u00f3n": "Nessuna installazione",
 "Cambiar clave API Cloud": "Modifica chiave API Cloud",
 "Librerías": "Librerie",
 "Plantillas": "Modelli",
 "No tiene configurada una clave API Cloud": "Non hai una chiave API Cloud configurata",
 "El traductor de librerías necesita su clave API Cloud para acceder a las librerías.": "Il traduttore di librerie necessita della chiave API Cloud per accedere alle librerie.",
 "Configurar clave": "Configura chiave",
 "UUID copiado al portapapeles": "UUID copiato negli appunti",
 "Error al copiar el UUID": "Errore durante la copia dell'UUID",
 "Idioma por defecto": "Lingua predefinita",
 "Traducir": "Traduci",
 "Copiar UUID": "Copia UUID",
 "Traducir con IA": "Traduci con l'IA",
 "Elija un contexto para poder traducir": "Scegli un contesto per poter tradurre",
 "Parámetro": "Parametro",
 "origen": "origine",
 "librería": "libreria",
 "plantilla": "modello",
 "Contexto de traducción": "Contesto di traduzione",
 "con error": "con errore",
 "cancelando…": "annullamento…",
 "pausando…": "messa in pausa…",
 "en pausa": "in pausa",
 "Guardar y cerrar": "Salva e chiudi",
 "Traducir todo": "Traduci tutto",
 "Traducir seleccionadas": "Traduci selezionate",
 "Pausar": "Metti in pausa",
 "Continuar": "Continua",
 "El texto en el idioma origen está vacío": "Il testo nella lingua di origine è vuoto",
 "No se ha podido traducir": "Non è stato possibile tradurre",
 "Falta configurar la URL del WebSocket del traductor": "Manca la configurazione dell'URL del WebSocket del traduttore",
 "No hay traducciones pendientes": "Non ci sono traduzioni in attesa",
 "No quedan traducciones pendientes": "Non restano traduzioni in attesa",
 "Traducción en pausa": "Traduzione in pausa",
 "Traducción cancelada": "Traduzione annullata",
 "Traducción terminada": "Traduzione completata",
 "Error en el proceso de traducción": "Errore nel processo di traduzione",
 "Corrija las traducciones no válidas antes de guardar": "Correggi le traduzioni non valide prima di salvare",
 "Traducciones guardadas": "Traduzioni salvate",
 "No se han podido guardar las traducciones": "Non è stato possibile salvare le traduzioni",
 "No se han podido cargar los parámetros de la librería": "Non è stato possibile caricare i parametri della libreria",
 "La traducción no puede superar los {max} caracteres": "La traduzione non può superare i {max} caratteri",
 "La traducción contiene caracteres no válidos": "La traduzione contiene caratteri non validi",
 "La traducción por defecto no puede estar vacía": "La traduzione predefinita non può essere vuota",
 "Clave API Cloud no válida": "Chiave API Cloud non valida",
 "Revise su clave API Cloud para poder usar el traductor de librerías.": "Controlla la chiave API Cloud per poter usare il traduttore di librerie.",
 "Revisar clave": "Controlla chiave",
 "cambios sin guardar": "modifiche non salvate",
 "Acceso al traductor de librerías": "Accesso al traduttore di librerie",
 "sólo no válidas": "solo non valide",
 "No tiene permiso para modificar esta librería": "Non hai i permessi per modificare questa libreria",
 "Asignar router": "Assegna router",
 "Contraseña del dispositivo": "Password del dispositivo",
 "Crear box": "Crea box",
 "Crear router": "Crea router",
 "Duplicado": "Duplicato",
 "El modem ya no está disponible": "Il modem non è più disponibile",
 "Este dispositivo no tiene ningún modem Teltonika asociado": "Questo dispositivo non ha nessun modem Teltonika associato",
 "Este dispositivo no tiene ningún router kiconex asignado": "Questo dispositivo non ha nessun router Kiconex assegnato",
 "Exportar a Excel": "Esporta in Excel",
 "Falta el número de serie": "Numero di serie mancante",
 "Falta la MAC": "MAC mancante",
 "Falta la contraseña": "Password mancante",
 "Fecha alta": "Data di creazione",
 "Fichero": "File",
 "Fila": "Riga",
 "IMEI no válido": "IMEI non valido",
 "Importar": "Importa",
 "Importar modems": "Importa modem",
 "Información de modem": "Informazioni modem",
 "Información de router": "Informazioni router",
 "Libres": "Liberi",
 "MAC no válida": "MAC non valido",
 "Modem": "Modem",
 "Modem Teltonika": "Modem Teltonika",
 "Modem borrado correctamente": "Modem eliminato correttamente",
 "Modem es un campo obligatorio": "Il modem è un campo obbligatorio",
 "Modems importados": "Modem importati",
 "No se ha podido cargar la información del router": "Impossibile caricare le informazioni del router",
 "No se ha podido leer el fichero": "Impossibile leggere il file",
 "Nuevo modem": "Nuovo modem",
 "Nuevo repuesto": "Nuovo ricambio",
 "Nuevo router": "Nuovo router",
 "Observaciones": "Osservazioni",
 "Organización es un campo obligatorio": "L'organizzazione è un campo obbligatorio",
 "Repetido en el fichero": "Ripetuto nel file",
 "Revisa los campos marcados": "Controlla i campi evidenziati",
 "Router": "Router",
 "Router (dato antiguo)": "Router (dato precedente)",
 "Router borrado correctamente": "Router eliminato correttamente",
 "Router no disponible": "Router non disponibile",
 "Router terminado": "Router finito",
 "Seleccionar fichero": "Seleziona il file",
 "Seleccionar router": "Seleziona il router",
 "Sin modem Teltonika": "Nessun modem Teltonika",
 "Sin tipo": "Nessun tipo",
 "Stock Kiconex": "Stock Kiconex",
 "Stock Teltonika": "Stock Teltonika",
 "Tipo": "Tipo",
 "Tipo Teltonika": "Tipo Teltonika",
 "Tracker": "Tracker",
 "Transformados": "Trasformati",
 "UUID router": "UUID router",
 "Versión placa": "Versione scheda",
 "Válido": "Valido",
 "Ya existe en el sistema": "Già presente nel sistema",
 "duplicadas": "duplicate",
 "filas leídas": "righe lette",
 "válidas": "valide",
 "¡IMEI erróneo!": "IMEI sbagliato!",
 "Lista routers": "Elenco router",
 "Routers asignados": "Router assegnati",
 "Seleccionar ICC": "Seleziona ICC",
  "Se deben renovar al menos": "Occorre rinnovare almeno",
},
  "plural": "(n != 1)"
  };
